module.exports = __webpack_public_path__ + "static/media/hotel-illustration--full.2730fca4.svg";